angular.module('pe4h').run(['$templateCache', function($templateCache) {
  $templateCache.put('components/proposals/client/client-proposal-list.html',
    '<div id="client-proposals" class="project-proposals" ng-controller="ClientProposalList">\n' +
    '    <!-- Proposals -->\n' +
    '    <div class="project-proposals-number">{{project.ProposalsCount}}</div>\n' +
    '    <h3 class="mb30" style="padding-left: 10px">Proposals</h3>\n' +
    '    <!-- Alert message -->\n' +
    '    <div class="alert alert-proposal alert-info" style="padding-left: 10px" ng-show="project.ProposalsCount==0" role="alert">\n' +
    '        <a class="close alt" data-dismiss="alert" aria-label="Close"></a>\n' +
    '        You don\'t have any proposals at the moment. We will notify you immediately when a proposal is submitted. The active proposals will be listed below.\n' +
    '    </div>\n' +
    '\n' +
    '    <!-- Proposal List -->\n' +
    '    <div ng-repeat="proposal in proposalList" style="padding: 0 20px 10px 10px" ng-class="{\'proposal-not-viewed\': !proposal.HasBeenViewed}">\n' +
    '        <div class="project-rate range">\n' +
    '            <span id="estimate">\n' +
    '                Estimate:\n' +
    '            </span>\n' +
    '            <span ng-if="proposal.Estimate"><font/>{{proposal.Estimate | currency:"":2}}\n' +
    '                <span ng-if="proposal.Hourly==true">/hr</span>\n' +
    '            </span>\n' +
    '            <span ng-if="(!proposal.Estimate) && (!proposal.Hourly)"> <font/>{{proposal.LowestRange | currency:"":2}} - <font/>{{proposal.HighestRange | currency:"":2}}\n' +
    '            </span>\n' +
    '            <br>\n' +
    '            <a class="btn btn-primary btn-sm pull-right" ng-show="project.Status == \'open\' || project.Status == \'expired\'" ng-click="hire(proposal.Id, proposal.User.FullName)" href="">Hire</a>\n' +
    '            <a class="done" ng-show="proposal.Status == \'hired\'">\n' +
    '                <i class="fa fa-check fa-lg green"></i><br>Hired</a>\n' +
    '        </div>\n' +
    '        <ul class="list-inline user-project" ng-class="{active: proposal.Status == \'hired\'}">\n' +
    '            <li class="user-profile-photo">\n' +
    '                <a href="" ui-sref="proposal({proposalId: proposal.Id, uid: project.UID})" ng-class="{\'active\': proposal.ClientUnreadMessages>0, \'inactive\': proposal.ClientUnreadMessages==0}">{{proposal.MessagesCount}}</a>\n' +
    '                <!-- Keep second background-image avater.png as is! -->\n' +
    '                <a class="user-photo" style="background-image:url({{proposal.User.Picture.Url}}),url(assets/img/avatar.png);" ui-sref="profileProposal({proposalId: proposal.Id})"></a>\n' +
    '            </li>\n' +
    '            <li>\n' +
    '                <a href="" ui-sref="profileProposal({proposalId: proposal.Id})">\n' +
    '                    <h5>{{proposal.User.FirstName}} {{proposal.User.LastName}}</h5>\n' +
    '                </a>\n' +
    '                <p><span ng-show="proposal.User.City">{{proposal.User.City}},</span> {{proposal.User.State}}</p>\n' +
    '                <!-- Rating -->\n' +
    '                <div ng-show="proposal.Status == \'hired\' && (proposal.ReviewScore != null)">\n' +
    '                    <div class="rating user">\n' +
    '                        <span ng-repeat="i in [5, 4, 3, 2, 1]" ng-class="{\'on\': i <= proposal.ReviewScore}"></span>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '                <a class="icon-proposal" href="" ui-sref="proposal({proposalId: proposal.Id, uid: project.UID})">View</a>\n' +
    '            </li>\n' +
    '            <li class="project-review" ng-show="((proposal.Status == \'completed\') || (proposal.Status == \'completedDisReq\')) && (proposal.ReviewScore == null)">\n' +
    '                <!-- Review -->\n' +
    '                <div id="project-review" class="message-box collapse in">\n' +
    '                    <form id="reviewForm" name="reviewForm">\n' +
    '                        <h4 class="mt20 mb20">Review</h3>\n' +
    '                        <h5>Rate</h5>\n' +
    '                        <fieldset class="rating-star">\n' +
    '                            <div class="rating">\n' +
    '                                <span ng-click="setStars(5)" ng-mouseover="setMousePosition(5)" ng-mouseleave="setMousePosition(0)" ng-class="{\'on\': review.stars > 4 || review.mousePosition > 4}"></span>\n' +
    '                                <span ng-click="setStars(4)" ng-mouseover="setMousePosition(4)" ng-mouseleave="setMousePosition(0)" ng-class="{\'on\': review.stars > 3 || review.mousePosition > 3}"></span>\n' +
    '                                <span ng-click="setStars(3)" ng-mouseover="setMousePosition(3)" ng-mouseleave="setMousePosition(0)" ng-class="{\'on\': review.stars > 2 || review.mousePosition > 2}"></span>\n' +
    '                                <span ng-click="setStars(2)" ng-mouseover="setMousePosition(2)" ng-mouseleave="setMousePosition(0)" ng-class="{\'on\': review.stars > 1 || review.mousePosition > 1}"></span>\n' +
    '                                <span ng-click="setStars(1)" ng-mouseover="setMousePosition(1)" ng-mouseleave="setMousePosition(0)" ng-class="{\'on\': review.stars > 0 || review.mousePosition > 0}"></span>\n' +
    '                            </div>\n' +
    '                        </fieldset>\n' +
    '                        <h5>Review</h5>\n' +
    '                        <textarea\n' +
    '                            required="true"\n' +
    '                            ng-maxlength="3000"\n' +
    '                            id="review"\n' +
    '                            name="review"\n' +
    '                            ng-model="review.message"\n' +
    '                            class="form-control"\n' +
    '                            rows="7"\n' +
    '                            placeholder="Describe quality of the work you received and overall experience..."\n' +
    '                            onfocus="this.placeholder=\'\'"\n' +
    '                            onblur="this.placeholder=\'DESCRIBE quality of the work you received and overall experience...\'"></textarea>\n' +
    '                        <div class="help-block" ng-class="{ \'errors\': reviewForm.review.$touched && reviewForm.review.$invalid }" ng-messages="reviewForm.review.$error" ng-if="reviewForm.review.$touched">\n' +
    '                            <p ng-message="maxlength">This field is too long.</p>\n' +
    '                            <p ng-message="required">This field is required</p>\n' +
    '                        </div>\n' +
    '                        <small>Review can\'t be edited after posting.</small>\n' +
    '                        <div class="text-right mt10">\n' +
    '                            <button type="button" ng-click="postReview(proposal.Id, proposal.User.FullName)" ng-disabled="reviewForm.$invalid || isInvalid()" class="btn btn-primary btn-lg btn-four" data-toggle="modal" data-target="#modal-thanks">Post</button>\n' +
    '                        </div>\n' +
    '                    </form>\n' +
    '                </div>\n' +
    '            </li>\n' +
    '        </ul>\n' +
    '    </div>\n' +
    '</div>\n' +
    '\n' +
    '<!-- Modal Hire -->\n' +
    '<script type="text/ng-template" id="modal-hire.html">\n' +
    '    <div class="modal-header">\n' +
    '        <a class="close" data-dismiss="modal" ng-click="$close();" aria-label="Close">\n' +
    '            <i class="fa fa-times"></i>\n' +
    '        </a>\n' +
    '        <h4 class="modal-title">Hire Now</h4>\n' +
    '    </div>\n' +
    '    <div class="modal-body">\n' +
    '        <p>\n' +
    '            Please confirm, that you \'Agree\' to hire\n' +
    '            {{name}}\n' +
    '            for your project.\n' +
    '            <br>\n' +
    '            <br>\n' +
    '            We will send a notification about your decision immediately.\n' +
    '        </p>\n' +
    '    </div>\n' +
    '    <div class="modal-footer">\n' +
    '        <button type="button" ng-click="$close()" class="btn btn-default">No</button>\n' +
    '        <button ng-click="agreed()" class="btn btn-primary">Agree</button>\n' +
    '    </div>\n' +
    '</script>\n' +
    '\n' +
    '<script type="text/ng-template" id="modal-thanks.html">\n' +
    '    <div class="modal-header">\n' +
    '        <a class="close" ng-click="$close();" aria-label="Close">\n' +
    '            <i class="fa fa-times"></i>\n' +
    '        </a>\n' +
    '        <h4 class="modal-title">Review Posted</h4>\n' +
    '    </div>\n' +
    '    <div class="modal-body">\n' +
    '        <p>\n' +
    '            Thank you for your feedback.\n' +
    '            <br>\n' +
    '            <br>\n' +
    '            {{name}}\n' +
    '            will be notified immediately.\n' +
    '        </p>\n' +
    '    </div>\n' +
    '    <div class="modal-footer">\n' +
    '        <button ng-click="$close();" type="button" class="btn btn-primary">OK</button>\n' +
    '    </div>\n' +
    '</script>\n' +
    '');
}]);
